import React, {memo, useMemo} from "react"
import {lineOptions} from "../settings/options"
import {Pie} from "react-chartjs-2"
import {useHistory} from "react-router-dom"
import {useSelector} from "react-redux"
import {onClickHandler} from "../../../utils/onclick"
import {useLocalization} from "../../../hooks/localization"
import useChartLoader from "../hooks/chart-loader"

type Props = {
    amountStatus: (order: number) => void
    label: string
    data: object
    page: number
}
export const PieChart = memo(function PieChart({label, amountStatus, data, page}: Props) {
    const history = useHistory()
    const {t} = useLocalization()
    const energyControlList = useSelector(state => state.control.energyState)
    const {isLoaded, loading} = useChartLoader()
    const amountType = useMemo(() => {
        switch (energyControlList.currency_unit) {
            case "try":
                return "₺"
            case "usd":
                return "$"
            case "eur":
                return "€"
            case "gbp":
                return "£"
        }
    }, [energyControlList])
    return (
        <div className="energy-box" onDoubleClick={() => history.push(`/energy/${page}`)}>
            {loading && (
                <div className="chart-spin-container">
                    <div className="chart-spin" />
                </div>
            )}
            <span style={isLoaded}>
                <span>
                    {t("energy_page.consumption_chart")}&nbsp;<small>(kW/h)</small>
                </span>
                <span>
                    <button
                        {...onClickHandler(() => amountStatus(1))}
                        className={`${label === "hour" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.hour")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(2))}
                        className={`${label === "day" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.day")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(3))}
                        className={`${label === "month" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.month")}
                    </button>
                </span>
            </span>
            <div style={{width: "350px", padding: "0.3rem", flexDirection: "row", ...isLoaded}} className="energy-page">
                {/* @ts-ignore*/}
                <Pie data={data} options={lineOptions} width={100} height={50} />
            </div>
        </div>
    )
})
